import { styled } from 'linaria/react';

export const StyledWrapper = styled.div`
  padding: 32px 0 8px;
`;
